// Shared open/close motion for product, service, FAQ and header disclosures.
(function(){
 const controllers=new WeakMap(),reduced=matchMedia('(prefers-reduced-motion: reduce)');
 document.querySelectorAll('details').forEach(details=>{
  const summary=details.querySelector(':scope > summary');if(!summary)return;
  const panel=document.createElement('div');panel.className='disclosure-panel';
  let node=summary.nextSibling;while(node){const next=node.nextSibling;panel.append(node);node=next}details.append(panel);
  let animation=null,targetOpen=details.open,version=0;
  function setOpen(open){
   const wasOpen=details.open,start=wasOpen?panel.getBoundingClientRect().height:0,startOpacity=wasOpen?parseFloat(getComputedStyle(panel).opacity):0;
   targetOpen=open;const current=++version;animation?.cancel();animation=null;
   summary.setAttribute('aria-expanded',String(open));
   if(reduced.matches){details.open=open;panel.style.overflow='';return}
   if(!wasOpen&&!open)return;
   details.open=true;panel.style.overflow='hidden';
   const end=open?panel.scrollHeight:0;
   animation=panel.animate([{height:start+'px',opacity:startOpacity},{height:end+'px',opacity:open?1:0}],{duration:230,easing:'cubic-bezier(.2,.75,.25,1)',fill:'both'});
   animation.onfinish=()=>{if(current!==version)return;details.open=targetOpen;animation.cancel();animation=null;panel.style.overflow=''};
  }
  summary.setAttribute('aria-expanded',String(targetOpen));
  summary.addEventListener('click',e=>{e.preventDefault();setOpen(!targetOpen)});
  controllers.set(details,{setOpen});
 });
 window.MJ_DISCLOSURES={close:details=>controllers.get(details)?.setOpen(false)};
})();
